/**
 * SUPPLEMENT HERO BANNER - INTERACTIVE JAVASCRIPT
 * Handles micro-interactions, 3D tilt effects, and Shopify Customizer lifecycle events.
 */

(function () {
  'use strict';

  class SupplementHeroSection {
    constructor(container) {
      this.container = container;
      this.imageCard = container.querySelector('[data-sph-tilt]');
      this.buttons = container.querySelectorAll('.sph-btn');
      
      this.init();
    }

    init() {
      this.init3dTilt();
      this.initButtonRipples();
      this.initScrollAnimations();
    }

    /**
     * 3D Tilt effect on hero product image card
     */
    init3dTilt() {
      if (!this.imageCard || window.innerWidth < 992) return;

      const card = this.imageCard;
      const inner = card.querySelector('.sph-image-inner');

      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        
        const rotateX = ((y - centerY) / centerY) * -10; // max 10deg tilt
        const rotateY = ((x - centerX) / centerX) * 10;

        if (inner) {
          inner.style.transform = `perspective(1000px) rotateX(${rotateX.toFixed(2)}deg) rotateY(${rotateY.toFixed(2)}deg) scale3d(1.02, 1.02, 1.02)`;
        }
      });

      card.addEventListener('mouseleave', () => {
        if (inner) {
          inner.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)';
        }
      });
    }

    /**
     * Ripple click feedback on CTA buttons
     */
    initButtonRipples() {
      this.buttons.forEach((btn) => {
        btn.addEventListener('click', function (e) {
          const rect = this.getBoundingClientRect();
          const ripple = document.createElement('span');
          
          const size = Math.max(rect.width, rect.height);
          const x = e.clientX - rect.left - size / 2;
          const y = e.clientY - rect.top - size / 2;

          ripple.style.width = ripple.style.height = `${size}px`;
          ripple.style.left = `${x}px`;
          ripple.style.top = `${y}px`;
          ripple.className = 'sph-btn-ripple';

          const existingRipple = this.querySelector('.sph-btn-ripple');
          if (existingRipple) {
            existingRipple.remove();
          }

          this.appendChild(ripple);

          setTimeout(() => {
            ripple.remove();
          }, 600);
        });
      });
    }

    /**
     * Intersection Observer for smooth entrance animations
     */
    initScrollAnimations() {
      if (!('IntersectionObserver' in window)) return;

      const animatedElements = this.container.querySelectorAll('.sph-badge, .sph-title, .sph-description, .sph-feature-card, .sph-actions, .sph-trust-bar, .sph-image-card');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('sph-in-view');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );

      animatedElements.forEach((el) => observer.observe(el));
    }
  }

  // Add dynamically inserted ripple styles
  const style = document.createElement('style');
  style.textContent = `
    .sph-btn { position: relative; overflow: hidden; }
    .sph-btn-ripple {
      position: absolute;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.4);
      transform: scale(0);
      animation: sphRipple 0.6s linear;
      pointer-events: none;
    }
    @keyframes sphRipple {
      to {
        transform: scale(4);
        opacity: 0;
      }
    }
    .sph-badge, .sph-title, .sph-description, .sph-feature-card, .sph-actions, .sph-trust-bar, .sph-image-card {
      opacity: 0;
      transform: translateY(20px);
      transition: opacity 0.6s cubic-bezier(0.16, 1, 0.3, 1), transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
    }
    .sph-in-view {
      opacity: 1 !important;
      transform: translateY(0) !important;
    }
  `;
  document.head.appendChild(style);

  // Initialize all instances on page load
  function initAllSections() {
    const sections = document.querySelectorAll('[data-section-type="supplement-hero"]');
    sections.forEach((section) => {
      if (!section.dataset.initialized) {
        new SupplementHeroSection(section);
        section.dataset.initialized = 'true';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  // Shopify Theme Editor Integration
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="supplement-hero"]');
    if (section) {
      new SupplementHeroSection(section);
    }
  });
})();
